import PeopleIcon from "Assets/SVG/PeopleIcon";
import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { UsersForm } from "Features/Users";
import { useNavigate } from "react-router-dom";

const NewUser = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newUser')} icon={<PeopleIcon />} includeBox>
            <UsersForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default NewUser
